import { useDataProvider } from 'react-admin';
import { useQuery } from '@tanstack/react-query';

export const useDeviceGroups = () => {
    const dataProvider = useDataProvider();

    return useQuery({
        queryKey: ['device-group'],
        queryFn: () =>
            dataProvider.getList('device-group', {
                pagination: { page: 1, perPage: 100 },
                sort: { field: 'name', order: 'ASC' },
                filter: {},
            }),
        select: response => response.data || [],
    });
};
